import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Sort = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/sort">
        <g id="sort">
          <path
            id="Vector"
            d="M14 5.16663H2C1.72667 5.16663 1.5 4.93996 1.5 4.66663C1.5 4.39329 1.72667 4.16663 2 4.16663H14C14.2733 4.16663 14.5 4.39329 14.5 4.66663C14.5 4.93996 14.2733 5.16663 14 5.16663Z"
          />
          <path
            id="Vector_2"
            d="M12 8.5H4C3.72667 8.5 3.5 8.27333 3.5 8C3.5 7.72667 3.72667 7.5 4 7.5H12C12.2733 7.5 12.5 7.72667 12.5 8C12.5 8.27333 12.2733 8.5 12 8.5Z"
          />
          <path
            id="Vector_3"
            d="M9.33464 11.8334H6.66797C6.39464 11.8334 6.16797 11.6067 6.16797 11.3334C6.16797 11.06 6.39464 10.8334 6.66797 10.8334H9.33464C9.60797 10.8334 9.83464 11.06 9.83464 11.3334C9.83464 11.6067 9.60797 11.8334 9.33464 11.8334Z"
          />
        </g>
      </g>
    </svg>
  );
};

Sort.displayName = 'Sort';
